<template>
  <div id="user-edit-account-details">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h5>Application Details</h5>
      </div>
    </div>

    <div class="vx-row my-4">
      <div class="vx-col w-1/2">
        <h5>{{ data_local.ApplicationName }}</h5>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <label class="vs-input--label font-bold">Description</label>
        <p>{{ data_local.ApplicationDescription }}</p>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col w-1/2">
        <div class="vx-row">
          <div class="vx-col w-1/2"><label class="vs-input--label font-bold">Client ID</label></div>
          <div class="vx-col w-1/2"><p class="break-words">{{ data_local.ExternalIdentity_Key }}</p>
          </div>
        </div>
      </div>
      <div class="vx-col w-1/2">
        <div class="vx-row">
          <div class="vx-col w-1/2"><label class="vs-input--label font-bold">Application type</label></div>
          <div class="vx-col w-1/2"><p>{{ app_type }}</p></div>
        </div>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col w-1/2">
        <div class="vx-row">
          <div class="vx-col w-1/2"><label class="vs-input--label font-bold">Client Secret</label></div>
          <div class="vx-col w-1/2"><p class="break-words">{{ data_local.ExternalIdentity.client_secret }}</p>
          </div>
        </div>
      </div>
      <div class="vx-col w-1/2">
        <div class="vx-row">
          <div class="vx-col w-1/2"><label class="vs-input--label font-bold">Application Login URI</label></div>
          <div class="vx-col w-1/2"><p>{{ data_local.ExternalIdentity.initiate_login_uri }}</p></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      applicationTypeOptions: [
        {
          label: 'Machine to Machine',
          value: 'non_interactive',
        },
        {
          label: 'Native',
          value: 'native',
        },
        {
          label: 'Regular Web Application',
          value: 'regular_web',
        },
        {
          label: 'Single Page Application',
          value: 'spa',
        },
      ]
    }
  },
  computed: {
    app_type() {
      const { app_type } = this.data.ExternalIdentity;
      const option = this.applicationTypeOptions.find(({value}) => value === app_type);
      return option ? option.label : '';
    },
    id() {
      return this.data.id;
    }
  },
}
</script>
